"use client";

import React from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from '../AnimatedSection';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

const OrganizationSection = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-brand-blue py-20 text-white" id="organization">
      <div className="container mx-auto px-6">
        <AnimatedSection delay={0.2}>
          <motion.div 
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl font-bold text-slate-300 mb-4">
              {t('organization.title')}
            </h2>
          </motion.div>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Logo Column */}
          <AnimatedSection delay={0.4}>
            <motion.div 
              className="flex flex-col items-center"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <Image 
                src="/images/organization/logo-org.png" 
                alt="Organization Logo"
                width={240}
                height={240}
                className="w-60"
              />
            </motion.div>
          </AnimatedSection>

          {/* Text Column */}
          <AnimatedSection delay={0.6}>
            <div className="space-y-8">
              <motion.p 
                className="text-slate-300"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                {t('organization.description')}
              </motion.p>
              
              <motion.div 
                className="font-bold text-xl"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                {t('organization.association_name')}
              </motion.div>
              
              <motion.p 
                className="text-slate-300"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                {t('organization.about')}
              </motion.p>

              <motion.div 
                className="pt-12"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
              >
                <h3 className="text-2xl font-bold text-slate-300 mb-6">
                  {t('organization.purpose_title')}
                </h3>
                
                <p className="text-slate-300">
                  {t('organization.purpose_description')}
                </p>
              </motion.div>
            </div>
          </AnimatedSection>
        </div>
        
        <AnimatedSection delay={0.8}>
          <motion.div 
            className="pt-8 mt-8 flex justify-center mx-auto max-w-lg max-h-100"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={t("organization.image_src")} alt="Organization chart" />
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default OrganizationSection;
